import { render, staticRenderFns } from "./impressionDetails.vue?vue&type=template&id=89340260&scoped=true&"
import script from "./impressionDetails.vue?vue&type=script&lang=js&"
export * from "./impressionDetails.vue?vue&type=script&lang=js&"
import style0 from "./impressionDetails.vue?vue&type=style&index=0&id=89340260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89340260",
  null
  
)

export default component.exports